import React from 'react'
import {style} from 'util/style'
import {useCart} from '../../../../util/cart'
import {useTranslation} from '../../../../util/i18n'
import {getPriceDiscount, toCents, toVisualPrice} from '../../../../util/price'
import {ProductType} from '../../pages'
import {Price} from '../../ui/Price'
import './Calculator.scss'
const styles = style('calculator', ['price'])

type CalculatorType = {
	deliveryPrice: string
	products: Array<ProductType>
}

export const Calculator: React.FC<CalculatorType> = ({
	deliveryPrice,
	products
}) => {
	const t = useTranslation('webshop').cart
	return (
		<div className={styles}>
			<div className={styles('total')}>
				<p className={styles('total-text')}>{t.total}</p>
				<CalculatorPrice deliveryPrice={deliveryPrice} products={products} />
			</div>
		</div>
	)
}

export const CalculatorPrice: React.FC<CalculatorType> = ({
	products,
	deliveryPrice
}) => {
	const {cart} = useCart()
	let totalPrice = 0
	let totalPriceWithDiscounts = 0

	const calculatedDeliveryPrice = toCents(deliveryPrice)

	if (!cart || !cart.products || cart.products.length === 0) return null

	cart.products.forEach((cartProduct) => {
		const product = products.find(
			(productDetail) => productDetail.id === Number(cartProduct.id)
		)
		if (!product) return
		const {price, quantity_discount: discounts} = product
		const quantity = cart.quantityOf(cartProduct)
		const totalProductVariants = cart.quantityOfVariantsWith(cartProduct.id)

		const fullProductPrice = toCents(price) * quantity

		const discount = getPriceDiscount(discounts, totalProductVariants)
			?.price_per_piece

		totalPrice += fullProductPrice
		if (!discount) {
			totalPriceWithDiscounts += fullProductPrice
		} else {
			const fullDiscountedPrice = toCents(discount) * quantity
			totalPriceWithDiscounts += fullDiscountedPrice
		}
	})

	const hasDiscount = totalPriceWithDiscounts !== totalPrice
	totalPrice += calculatedDeliveryPrice
	totalPriceWithDiscounts += calculatedDeliveryPrice

	return (
		<div className={styles.price}>
			{hasDiscount && (
				<div className={styles.price('placeholder')}>
					<Price discounted>{`€${toVisualPrice(totalPrice)}`}</Price>
				</div>
			)}
			<div className={styles.price('discount')}>
				<Price>{`€${toVisualPrice(totalPriceWithDiscounts)}`}</Price>
			</div>
		</div>
	)
}
